import { render, staticRenderFns } from "./CRadar.vue?vue&type=template&id=5032ebbf&scoped=true&"
import script from "./CRadar.vue?vue&type=script&lang=js&"
export * from "./CRadar.vue?vue&type=script&lang=js&"
import style0 from "./CRadar.vue?vue&type=style&index=0&id=5032ebbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032ebbf",
  null
  
)

export default component.exports